<template>
  <div id="submitted">
    <form>
      <ol class="questions">
        <li>
          <fieldset>
            <SessionStatus
              :submissionId="submissionId" 
              display="true" 
              fieldsToFilter="barcode_"
              formName="disasterRecovery" 
            />
            <ul class="actions">
                <li>
                  <em><a v-on:click="resetForm" id="return" class="button">Return to page</a></em> 
                </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
  </div>
</template>

<script>
import SessionStatus from '@/components/session/SessionStatus.vue'

export default {
  name: 'Submitted',
  props: { 
      submissionId: String,
      resetEnquiry: Function      
  },
  methods: {
    resetForm: function() {
      this.$emit('resetEnquiry');
    }
  },
  components: {
    SessionStatus
  }
}
</script>
  
<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>